module.exports = __webpack_public_path__ + "img/Agroforestry & Food.c8176f9a.jpg";